Namespace('Monitoring.Reports.DailyInsights')

class Monitoring.Reports.DailyInsights.ReportView extends Backbone.View
	className: 'daily-insights-report'

	initialize: (@options = {}) =>
		@options.colors = {
			negative: '#FF5722'
			neutral:  '#FFE082'
			positive: '#009688'
		}
		@isGraySection = true
		
	render: ->
		@$el.addClass(@options.account.toLowerCase().replace(' ', '-'))
		@renderHeader()
		@renderSections()

		return this
	
	renderHeader: =>
		header = new Monitoring.Reports.DailyInsights.HeaderView(@options)
		header.render()
		@$el.html(header.el)

	renderSections: =>
		sections = []
		for channel in @options.facebook
			sections.push(new Monitoring.Reports.DailyInsights.PostsView($.extend({}, @options, {title: 'Facebook', subtitle: "Posts", section: 'facebook', channel: channel, icon: true, graySection: @graySection()})))
		for channel in @options.instagram
			sections.push(new Monitoring.Reports.DailyInsights.PostsView($.extend({}, @options, {title: 'Instagram', subtitle: "Posts", section: 'instagram', channel: channel, icon: true, graySection: @graySection()})))
		for channel in @options.twitter
			sections.push(new Monitoring.Reports.DailyInsights.PostsView($.extend({}, @options, {title: 'Twitter', subtitle: "Posts", section: 'twitter', channel: channel, icon: true, graySection: @graySection()})))

		for section in sections
			section.render()
			@$el.append(section.el)

	graySection: =>
	 @isGraySection = !@isGraySection